import { Injectable, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { SafeResourceUrl } from "@angular/platform-browser";
import * as saveAs from "file-saver";
import * as moment from "moment";
import { Message, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { User } from ".";
import { AdministracionService } from "../administracion/administracion.service";
import { FiltroData } from "../modelo/FiltroData";
import { FiltrosData } from "../modelo/FiltrosData";
import { Invoice } from "../modelo/Invoice";
import { Reporte } from "../modelo/Reporte";
import { ResultsData, UIService } from "./services/ui.service";

/**
Objeto de control padre para todas las funcionalides-
Encapsula variables y comportamientos comunes a todo el sistema
*/
@Injectable()
export abstract class FazilController {
    
    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];
    
    
    //Manejo de contexto de usuario
    _currentUser: User;
    
    //UX
    ui: UIService;
    
    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    catalogoReportes: Reporte[] = [];
    reporte: Reporte = new Reporte();
    mostrarSelectorReporte: boolean = false;

    dtRangeInit: Date;
    dtRangeEnd: Date;
    dtRangeMonth: boolean = false;

    filtrosData: FiltrosData = new FiltrosData();
    mostrarMensajesResultData: boolean = false;
    resultsData: ResultsData;
    busqueda:string;
    
    //Variables de reportes
    mostrarVisualidorReporteRIDE: boolean = false;
    mostrarVisualidorReporteXML: boolean = false;
    mostrarVisualidorReporte: boolean = false;
    reporteGenerado: boolean = false;
    reporteFactura: Invoice = {} as Invoice;
    reporteURL: any; //Para lanzar el popup de vista previa
    reporteBLOB: any; //Para descargar el reporte
    
    //Estados de ejecución
    procesando: boolean = false;
    status: string = "";
    
    search:string = '';
    pageOptions = { page: 0, pageSize: 10, filter: '', orderBy: 'name', order:'ASC'};
    rows:number = 10; //TODO Esto podra salir de una configuracion
    totalRecords:number = 0;
    
    constructor(
        public uiService: UIService,
        public messageService: MessageService,
        public administracionService: AdministracionService,
        public _formBuilder: FormBuilder 
   ) {

        this.ui = uiService;
        moment.locale('es');
    }
    
    @Input()
    set currentUser(currentUser: User) {
        this._currentUser = currentUser
    }

    get currentUser() { return this._currentUser; }
    
    
    /**
    * Manejo de reportes
    */
    async generarReportePorFiltros(event: any) {
        this.reporteBLOB = null;
        this.reporteURL = null;
        this.reporteGenerado = false;
        this.mostrarVisualidorReporte = false;
        this.filtrosData.filtros = [];
        this.filtrosData.tipo = "excel";
        let filtro;

        filtro = new FiltroData();
        filtro.token = 'Titulo';
        filtro.valor = this.reporte.name;
        this.filtrosData.filtros.push(filtro);

        filtro = new FiltroData();
        filtro.token = 'estadoSRI';
        filtro.valor = this.status ? this.status : "APPLIED";
        this.filtrosData.filtros.push(filtro);


        if (this.dtRangeInit) {//Cargar el filtro de fechas

            filtro = new FiltroData();
            filtro.token = 'fechaInicial';
            filtro.valor = "" + this.dtRangeInit.toLocaleDateString();
            filtro.tipo = "Date";
            this.filtrosData.filtros.push(filtro);

            filtro = new FiltroData();
            filtro.token = 'fechaFinal';
            filtro.tipo = "Date";

            if (this.dtRangeEnd) {
                filtro.valor = "" + this.dtRangeEnd.toLocaleDateString();
            } else {
                filtro.valor = "" + new Date().toLocaleDateString();
            }
            this.filtrosData.filtros.push(filtro);
        }


        //Solicitar reporte con filtros
        if (this.filtrosData && this.filtrosData.filtros && this.filtrosData.filtros.length > 0) {

            //Parámetros del reporte
            if (this.reporte.url && this.reporte.url != '') {
                this.procesando = true;
                this.administracionService.generarReportePorFiltros(this.reporte.uuid, this.filtrosData).subscribe(
                    (responseBlob: any) => {

                        let blob: any = new Blob([responseBlob], { type: responseBlob.type });

                        if (this.filtrosData.tipo == 'pdf') {
                            const fileReader = new FileReader();
                            fileReader.onload = () => {
                                this.reporteURL = new Uint8Array(fileReader.result as ArrayBuffer);
                                this.reporteGenerado = true;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;

                            };
                            if (blob['type'] != '' && blob['size'] != 0) {
                                fileReader.readAsArrayBuffer(blob);
                                this.reporteBLOB = blob;
                            } else {
                                this.reporteGenerado = false;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;
                            }
                        } else {
                            this.saveAsEXCELFile(blob, this.reporte.name);
                            this.reporteGenerado = true;
                            this.mostrarVisualidorReporte = false;
                            this.procesando = false;
                        }

                    },
                    (err) => {
                        this.errors = err["errors"];
                        this.messageService.add({
                            severity: "error",
                            summary: this.errors["type"],
                            detail: `${this.errors["message"]}`,
                        });
                    }
                );
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Reporte inconsistente",
                    detail: `${this.reporte["nombre"]} no esta correctamente definido. Consulte con el administrador.`,
                });

                this.procesando = false;
            }
        }
    }
    
     /**
    * Manejo de archivos EXCEL
    */
    saveAsEXCELFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.xls';
            const path = fileName + '_descarga_' + new Date().getTime().toString() + ZIP_EXTENSION;
            saveAs(blob, path);
        });
    }
}